import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK, AUTH_GET_PERMISSIONS } from 'react-admin';
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from './common/common';
const apiUrl = RUN_TIME_API_ENDPOINT;

export default (type, params) => {
    console.log('inside authProvider===>');
    let url = "";
    if (type === AUTH_LOGIN) {
        const { username, password } = params;
        console.log('params inside authProvider===>', username, password);
        url = `${apiUrl}/login`;
        const options = CommonHeaderOption();
        options.method = 'POST';
        options.headers = {
            // 'authorization': tokenId,
            'Content-Type': 'application/json'
        };
        options.body = JSON.stringify({ email: username, password });
        // console.log('options to login',options);
        return fetch(url, options)
            .then(res => {
                console.log('res inside AUTH_LOGIN===>', res);
                if (res.status < 200 || res.status >= 300) {
                    throw new Error(res.statusText);
                }
                return res.json();
            })
            .then((resp) => {
                // this.setState({
                //     showLoader: false
                // });
                console.log('our use ', resp);
                // if ((resp.data.username === '') || (resp.data.username !== googleName)) {
                //     url = `${apiUrl}/whitelist_users/google_user_name`;
                //     const options = CommonHeaderOption();
                //     options.method = 'POST';
                //     options.body = JSON.stringify({ email, googleName });
                //     return fetch(url, options)
                //         .then(res => {
                if (resp.status === 'success') {
                    console.log('resp >>>', resp);
                    window.location.href = "/#";
                    localStorage.setItem('__state', JSON.stringify(resp.data));
                }

                //             // return res.json();
                //         }).catch(error => {
                //             console.log(error);
                //         })

                // }

                // e.preventDefault();
                console.log('resp our daa -->>', resp.data);
                // rollbarConfigUser(resp.data);
                // localStorage.setItem('__state', JSON.stringify(resp.data));
                // window.location.href = "/#";
            }).catch(error => {
                localStorage.removeItem('__state');
            });
        // return Promise.resolve();
    }
    // called when the user clicks on the logout button
    if (type === AUTH_LOGOUT) {
        url = `${apiUrl}/logout`;
        const options = CommonHeaderOption();
        options.method = 'POST';
        return fetch(url, options)
            .then(res => {
                if (res.status < 200 || res.status >= 300) {
                    throw new Error(res.statusText);
                }
                return res.json();
            })
            .then((resp) => {
                localStorage.removeItem('__state', JSON.stringify(resp.data));
            }).catch(error => {
                // ALL Error Handling Here
                localStorage.removeItem('__state');
            });
        // return Promise.resolve();
    }
    // called when the API returns an error
    if (type === AUTH_ERROR) {
        const { status } = params;
        if (status === 401 || status === 403) {
            localStorage.removeItem('__state');
            return Promise.reject();
        }
        return Promise.resolve();
    }
    // called when the user navigates to a new location
    if (type === AUTH_CHECK) {
        return localStorage.getItem('__state')
            ? Promise.resolve()
            : Promise.reject();
    }
    if (type === AUTH_GET_PERMISSIONS) {
        const __state = JSON.parse(localStorage.getItem('__state'));
        const digital_order_system = __state.digital_order_system;
        return digital_order_system ? Promise.resolve(digital_order_system) : Promise.reject();
        // const __state = JSON.parse(localStorage.getItem('__state'));
        // const role = __state._roles.name
        // console.log('our role is', role);
        // return role ? Promise.resolve(role) : Promise.reject();
    }
    return Promise.reject('Unknown method');
};